<wiz-vgroup [horizontalAlign]="'end'" [gap]=0 minWidth='150px' >
  <wiz-hgroup [verticalAlign]="'center'" [gap]="'0px'" width='100%' [horizontalAlign]="'center'">
    <!-- hours selector-->
    <div #hourDiv id="hourDiv" tabindex="1"
         (wheel)="onWheel($event, true)" 
         (mousedown)="onDragStart($event, SPINNER_HOUR_MODE)"
         (touchstart)="onDragStart($event, SPINNER_HOUR_MODE)"
         class="wiz-timepicker-column" >
      <span class="wiz-timepicker-cell" (click)="selectPrevious(true)"
        wizholdable (gapTime)="selectPrevious(true)"
        [ngClass]="{'wiz-timepicker-cell-disabled': hours[0].disabled}"
        width='40px' height='40px'>{{ hours[0].value }}</span>
      <span class="wiz-timepicker-cell wiz-timepicker-cell-selected" width='40px' height='40px'>{{ hours[1].value }}</span>
      <span class="wiz-timepicker-cell" (click)="selectNext(true)" 
        wizholdable (gapTime)="selectNext(true)"
        [ngClass]="{'wiz-timepicker-cell-disabled': hours[2].disabled}" width='40px' height='40px'>{{ hours[2].value }}</span>
    </div>
    <!-- hours and minutes separator-->
    <div class="wiz-timepicker-cell wiz-timepicker-cell-selected" width="10px" height="40px"><span> : </span></div>
    <!-- minutes selector -->
    <div #minuteDiv tabindex="2"
         (wheel)="onWheel($event, false)"
         (mousedown)="onDragStart($event, SPINNER_MINUTE_MODE)"
         (touchstart)="onDragStart($event, SPINNER_MINUTE_MODE)"
         class="wiz-timepicker-column" >
      <span class="wiz-timepicker-cell" (click)="selectPrevious(false)"
        wizholdable (gapTime)="selectPrevious(false)"
        [ngClass]="{'wiz-timepicker-cell-disabled': minutes[0].disabled}" width='40px' height='40px'>{{ minutes[0].value }}</span>
      <span class="wiz-timepicker-cell wiz-timepicker-cell-selected" width='40px' height='40px' >{{ minutes[1].value }}</span>
      <span class="wiz-timepicker-cell" (click)="selectNext(false)" 
        wizholdable (gapTime)="selectNext(false)" 
        [ngClass]="{'wiz-timepicker-cell-disabled': minutes[2].disabled}" width='40px' height='40px'>{{ minutes[2].value }}</span>
    </div>
    <wiz-spacer class="wiz-timepicker-cell wiz-timepicker-cell-selected" *ngIf="wizMeridiemMode" width="5px" height="40px"></wiz-spacer>
    <!-- Meridiem -->
    <div #meridiemDiv tabindex="3"
        *ngIf="wizMeridiemMode"
        (wheel)="onMeridiemWheel($event)"
        (mousedown)="onDragStart($event, SPINNER_MERIDIEM_MODE)"
        (touchstart)="onDragStart($event, SPINNER_MERIDIEM_MODE)"
        class="wiz-timepicker-column" >
      <span class="wiz-timepicker-cell" width='40px' height='40px' (click)="selectPreviousMeridiem()">{{ meridiems[0].value }}</span>
      <span class="wiz-timepicker-cell wiz-timepicker-cell-selected" width='40px' height='40px'>{{ meridiems[1].value }}</span>
      <span class="wiz-timepicker-cell" width='40px' height='40px' (click)="selectNextMeridiem()">{{ meridiems[2].value }}</span>
    </div>
  </wiz-hgroup>
  <wiz-button *ngIf="wizShowValidButton" class="wiz-timepicker-valid-button" [wizLabel]="'$.common.ok.$'" minWidth='40px' (wizClick)="onValid()"></wiz-button>
</wiz-vgroup>
